import { useTranslation } from 'react-i18next';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@shared/ui';

export function AccordionShowcase() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.dataDisplay.accordion.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.dataDisplay.accordion.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <Accordion type="single" collapsible className="w-full">
          <AccordionItem value="item-1">
            <AccordionTrigger>
              {t('uiLibrary.dataDisplay.accordion.items.0.title')}
            </AccordionTrigger>
            <AccordionContent>
              {t('uiLibrary.dataDisplay.accordion.items.0.content')}
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value="item-2">
            <AccordionTrigger>
              {t('uiLibrary.dataDisplay.accordion.items.1.title')}
            </AccordionTrigger>
            <AccordionContent>
              {t('uiLibrary.dataDisplay.accordion.items.1.content')}
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value="item-3">
            <AccordionTrigger>
              {t('uiLibrary.dataDisplay.accordion.items.2.title')}
            </AccordionTrigger>
            <AccordionContent>
              {t('uiLibrary.dataDisplay.accordion.items.2.content')}
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </CardContent>
    </Card>
  );
}
